import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
import { useSelector } from 'react-redux';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { useContact } from '../../crm-integration/hooks/useContact';
import { isKnownContact } from '../../contacts/operators/isKnownContact';
import { useIsBulkUpdated } from 'find-and-filter-data/bulk-operations/public';
import { hasConversationsInteract as getHasConversationsInteract } from '../../auth/selectors/hasConversationsInteract';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { useConversationIdByThreadId } from '../../crm-integration/hooks/useConversationIdByThreadId';
import InboxTicketHeader from '../components/ticket-header/InboxTicketHeader';
import ThreadHeader from '../components/thread-header/ThreadHeader';
import InboxHeaderActionsContainer from './InboxHeaderActionsContainer';
import { useAssociatedTickets } from 'svh-tickets-lib/tickets/public/hooks';
import { getUserPermissions } from '../../tickets/operators/ticketGetters';
import { getIsUngatedForLimitedTicketFunctionality } from '../../selectors/gateSelectors';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadAndTicketHeader = ({
  children,
  threadId,
  associatedTicket,
  asyncContact,
  currentUserCanViewTicket
}) => {
  if (currentUserCanViewTicket && associatedTicket) {
    return /*#__PURE__*/_jsx(InboxTicketHeader, {
      ticket: associatedTicket,
      asyncContact: asyncContact,
      threadId: threadId,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(ThreadHeader, {
    threadId: threadId,
    children: children
  });
};
ThreadAndTicketHeader.displayName = 'ThreadAndTicketHeader';
const InboxViewMemberDetailsHeader = ({
  threadId,
  toggleSidebar,
  openZorseTaxonomyPanel
}) => {
  const {
    asyncContact
  } = useContact({
    threadId
  });
  const isKnownVisitor = isKnownContact(getData(asyncContact));
  const hasThreadBeenBatchUpdated = useIsBulkUpdated(threadId);
  const hasConversationsInteract = useSelector(getHasConversationsInteract);
  const inboxId = useSelector(getCurrentInboxId);
  const {
    conversationId
  } = useConversationIdByThreadId({
    threadId
  });
  const {
    associatedTicket
  } = useAssociatedTickets({
    conversationId
  });
  const currentUserCanView = associatedTicket ? getUserPermissions(associatedTicket).currentUserCanView : false;
  const shouldLimitTicketFunctionality = useSelector(getIsUngatedForLimitedTicketFunctionality);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    errorLoggingTitle: "InboxViewMemberDetailsHeader",
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      children: /*#__PURE__*/_jsx(Box, {
        blockSize: "100%",
        grow: 1,
        shrink: 1,
        children: /*#__PURE__*/_jsx(ThreadAndTicketHeader, {
          associatedTicket: associatedTicket,
          threadId: threadId,
          asyncContact: asyncContact,
          currentUserCanViewTicket: !shouldLimitTicketFunctionality && currentUserCanView,
          children: /*#__PURE__*/_jsx(InboxHeaderActionsContainer, {
            isKnownVisitor: isKnownVisitor,
            disabled: hasThreadBeenBatchUpdated || !hasConversationsInteract,
            threadId: threadId,
            inboxId: inboxId,
            openTaxonomyPanel: openZorseTaxonomyPanel,
            toggleSidebar: toggleSidebar
          })
        })
      })
    })
  });
};
InboxViewMemberDetailsHeader.displayName = 'InboxViewMemberDetailsHeader';
export default InboxViewMemberDetailsHeader;